import {SponsoredContent} from "@proto/chatbot/v1alpha/chatbot"
import SponsoredArticleList from "./SponsoredArticleList"
import SponsoredProductList from "./SponsoredProductList"

interface IProps {
    message: string
}

const parse = (msg: string): SponsoredContent | false => {
    try {
        return JSON.parse(msg)
    } catch (e) {
        console.error(e)
        return false
    }
}

const SponsoredContentMessage = ({message}: IProps) => {
    try {
        const content = parse(message)
        if (!content) {
            return
        }

        return (
            <div className="relative">
                <SponsoredProductList products={content?.products} />
                <SponsoredArticleList articles={content?.articles} />
            </div>
        )
    } catch (e) {
        return
    }
}

export default SponsoredContentMessage
